<template>
  <div class="panel-body">
    <div class="text-size-20">
      セルモンエージェントの各種設定を行うことができます。
    </div>
    <div class="fba-container">
      <div class="border-bottom">
        <div class="text-size-24 border-top pd-l-10 pd-r-35 pd-t-15">FBA 長期在庫</div>
        <div class="pd-l-30 pd-r-30 pd-t-10 pd-b-10">
          <div class="border-bottom">
            <span class="text-size-20 text-primary font-bold pd-r-20">
              <i class="fa fa-pencil-square text-size-28" aria-hidden="true"></i>
              Amazon返送納品の提案を通知する
            </span>
            <toggle-button
              v-model="enableNotice"
              :labels="{checked: 'ON', unchecked: 'OFF'}"
              :height=30
              :width=62
              :sync="true"
            />
          </div>
          <div class="pd-l-30 pd-r-30 pd-t-10 pd-b-20">
            次回のAmazon請求において、FBA長期在庫追加手数料の対象商品がある場合、メールで通知を受け取ります。<br>
            毎月5日、20日時点で対象商品がある場合にのみ通知します。<br>
            プレミアムにご登録済みの方に通知します。※トライアル中の方はご利用になれません。
          </div>
        </div>
      </div>
      <div>
        <div class="text-size-24 border-top pd-l-10 pd-r-35 pd-t-15">セルモン出品</div>
        <div class="pd-l-30 pd-r-30 pd-t-10 pd-b-10">
          <div class="border-bottom">
            <span class="text-size-20 text-primary font-bold pd-r-20">
              <i class="fa fa-pencil-square text-size-28" aria-hidden="true"></i>
              セルモンへの出品提案を通知する
            </span>
            <toggle-button
              v-model="enableNoticeSelmon"
              :labels="{checked: 'ON', unchecked: 'OFF'}"
              :height=30
              :width=62
              :sync="true"
            />
          </div>
          <div class="pd-l-30 pd-r-30 pd-t-10 pd-b-20">
            セルモンへ出品可能な商品がある場合、メールで通知を受け取ります。<br>
            毎月10日、25日時点で対象商品がある場合にのみ通知します。<br>
            プレミアムにご登録済みの方に通知します。※トライアル中の方はご利用になれません。
          </div>
          <button class="btn btn-warning w-120" @click="handleClickUpdate()" :disabled="disableUpdate">更新</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SalemonAgentService from '@/services/salemonagentservice'
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'

export default {
  data () {
    return {
      enableNotice: true,
      enableNoticeSelmon: true,
      loader: null
    }
  },
  computed: {
    enableAgentNotice () {
      return this.$store.getters.getUser.enableAgentNotice
    },
    enableAgentNoticeSelmon () {
      return this.$store.getters.getUser.enableAgentNoticeSelmon
    },
    disableUpdate () {
      return this.enableNotice === this.enableAgentNotice && this.enableNoticeSelmon === this.enableAgentNoticeSelmon
    }
  },
  created () {
    this.enableNotice = this.enableAgentNotice
    this.enableNoticeSelmon = this.enableAgentNoticeSelmon
  },
  methods: {
    async handleClickUpdate () {
      let logParams = {
        name: eventCode.salemon_agent.settings.click_update,
        properties: { enableNotice: this.enableNotice, enableNoticeSelmon: this.enableNoticeSelmon }
      }
      EventService.postTrackLog(logParams)
      this.loader = this.$loading.show()
      await SalemonAgentService.updateSettingNotice({ enableNotice: this.enableNotice, enableNoticeSelmon: this.enableNoticeSelmon })
        .then((response) => {
          this.$store.commit('setEnableAgentNotice', { enableNotice: this.enableNotice, enableNoticeSelmon: this.enableNoticeSelmon })
          this.$store.commit('toggleModal', {
            show: true,
            message: '更新が完了しました。'
          })
        })
        .catch((error) => {
          this.$events.fire('handleError', error)
        })
        .finally(() => {
          this.loader && this.loader.hide()
        })
    }
  },
  mounted () {
    let logParams = {
      name: eventCode.salemon_agent.settings.show,
      properties: {}
    }
    EventService.postTrackLog(logParams)
  }
}
</script>
<style scoped>
.fba-container {
  border-top: 1px solid #ccc;
  max-width: 1000px;
}
.text-primary {
  color: #008cc6;
}
.border-bottom {
  border-bottom: 1px solid #ccc;
}
.border-top {
  border-top: 3px solid #008cc6 !important;
  width: max-content;
}
@media (max-width: 425px) {
  .text-size-20 {
    font-size: 16px;
  }
  .pd-l-30 {
    padding-left: unset;
  }
  .pd-r-30 {
    padding-right: unset;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/salemonAgent/Settings.vue